import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { ProgramId } from '@/enums';
import { getCountryCode } from '@/helpers/CountryCodeHelper';
import { isEnableGA } from '@/hooks/useGoogleAnalytic';
import { getHost } from '@/hooks/useRouteSection';
import i18next from '@/i18n/config';
import { persistor, store } from '@/store';
import GlobalStyle from '@/theme/global-style';
import { useLocation } from '@reach/router';
import { Script } from 'gatsby';
import { useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from '../../theme/theme';
import IdleTimeOutHandler from '../common/IdleTimeout';
import ChatboxComponent from '../common/LiveChatBox';
import Footer from './Footer';
import Header from './Header';
import { GlobalIOSButtonFix } from '../common';

declare global {
  interface Window {
    dataLayer: Array<any>;
  }
}

const Layout = (props: any) => {
  const [, setIsActive] = useState(true);
  const host = getHost() || '';
  const location = useLocation();
  const GTMCode = host.includes(ProgramId.UAT)
    ? ProgramId.UAT_GTM
    : ProgramId.PROD_GTM;

  // check the route require to display header
  const handleHeaderMenu = () => {
    const paths = new Set(['quotation', 'amla']);
    const parts = location.pathname.split('/').filter((part) => part != '');

    if (parts.length > 0) {
      const strippedPath = parts[parts.length - 1];
      if (paths.has(strippedPath)) return false;
      return true;
    } else {
      return true;
    }
  };

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {isEnableGA[getCountryCode()] && (
            <Script id="first-unique-id">
            {`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-${GTMCode}');
            `}
            </Script>
          )}

          <IdleTimeOutHandler
            onActive={() => {
              setIsActive(true);
            }}
            onIdle={() => {
              setIsActive(false);
            }}
          />
          <GlobalStyle />
          <GlobalIOSButtonFix />
          <ThemeProvider theme={theme}>
            {handleHeaderMenu() && <Header />}
            <Styles>
              <I18nextProvider i18n={i18next}>{props.children}</I18nextProvider>
            </Styles>
            <ChatboxComponent />
            {handleHeaderMenu() && <Footer />}
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </>
  );
};

export default Layout;

const Styles = styled.div`
  margin: 0px auto;
  padding-top: 0px;
  min-height: calc(100vh - 10rem);
`;
